module.exports = __webpack_public_path__ + "img/login_logo.32c67e1a.png";